import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "md_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const publicApi = axios.create({ baseURL: API });

// Endpoints
export const submitLead = (payload) => publicApi.post("/leads", payload);
export const fetchTestimonials = () => publicApi.get("/testimonials");
export const login = (email, password) => publicApi.post("/auth/login", { email, password });
export const me = () => api.get("/auth/me");
export const createTestimonial = (payload) => api.post("/testimonials", payload);
export const updateTestimonial = (id, payload) => api.put(`/testimonials/${id}`, payload);
export const deleteTestimonial = (id) => api.delete(`/testimonials/${id}`);
export const uploadMedia = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
};

export const mediaUrl = (path) => (path ? `${API}/media/${path}` : null);
